module.exports = __webpack_public_path__ + "static/images/smartrate-demand-check.98cbc8edd53c840d5fac575c2f0dabcf.svg";